import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { api } from "@api/api";
import { ApiError } from "@shared/types";
import { PartnerTier } from "@modules/partners/types";
import { TierFormValues } from "@modules/partners/validations";

export const listTiersQueryKey = ["v1/partner_tier_admin"];

export function useCreateTierMutation() {
  const translate = useTranslate();
  const { open } = useNotification();
  const queryClient = useQueryClient();

  return useMutation<PartnerTier, ApiError, TierFormValues>({
    mutationFn: async (values) => {
      const { data } = await api.post<PartnerTier>("/v1/partner_tier_admin/", values);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: listTiersQueryKey, refetchType: "all" });
      open?.({ type: "success", message: translate("v1/partner_tier_admin.success.create") });
    },
    onError: (error: ApiError) => {
      open?.({ type: "error", message: error.response.data.error });
    },
  });
}
